import { render, staticRenderFns } from "./Scantron.vue?vue&type=template&id=b23f8100&"
import script from "./Scantron.vue?vue&type=script&lang=js&"
export * from "./Scantron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports